import {
  FETCH_SAVE_DEVICE_FAILURE,
  FETCH_SAVE_DEVICE_REQUEST,
  FETCH_SAVE_DEVICE_SUCCESS,
  GET_DEVICE_TOKEN,
} from '../actions/actionTypes';

export default function deviceTokenReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_SAVE_DEVICE_REQUEST:
      return state;
    case FETCH_SAVE_DEVICE_SUCCESS:
      return action.payload;
    case FETCH_SAVE_DEVICE_FAILURE:
      return { error: action.payload };
    case GET_DEVICE_TOKEN:
      return { deviceToken: action.payload };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/NotificationReducer.js